import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixReplay10Icon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M3 12C3 13.78 3.52784 15.5201 4.51677 17.0001C5.50571 18.4802 6.91131 19.6337 8.55585 20.3149C10.2004 20.9961 12.01 21.1743 13.7558 20.8271C15.5016 20.4798 17.1053 19.6226 18.364 18.364C19.6226 17.1053 20.4798 15.5016 20.8271 13.7558C21.1743 12.01 20.9961 10.2004 20.3149 8.55585C19.6337 6.91131 18.4802 5.50571 17.0001 4.51677C15.5201 3.52784 13.78 3 12 3C9.48395 3.00947 7.06897 3.99122 5.26 5.74L3 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M3 3V8H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M8.60254 15.8213V11.4316H8.58301L8.07031 11.7783C7.81641 11.9395 7.67969 11.9883 7.51855 11.9883C7.19629 11.9883 6.96191 11.7539 6.96191 11.4316C6.96191 11.1924 7.1084 10.9775 7.39648 10.7969L8.19238 10.2646C8.57324 10.0205 8.91992 9.9082 9.24707 9.9082C9.81836 9.9082 10.1992 10.2939 10.1992 10.8896V15.8213C10.1992 16.373 9.91113 16.6807 9.40332 16.6807C8.89062 16.6807 8.60254 16.3682 8.60254 15.8213ZM11.5855 13.4678V13.1113C11.5855 11.124 12.6061 9.83008 14.2467 9.83008C15.8922 9.83008 16.8736 11.0996 16.8736 13.1113V13.4678C16.8736 15.4502 15.8434 16.7637 14.2125 16.7637C12.5816 16.7637 11.5855 15.4795 11.5855 13.4678ZM13.2066 13.1162V13.4629C13.2066 14.7324 13.5875 15.4746 14.232 15.4746C14.8717 15.4746 15.2574 14.7275 15.2574 13.4629V13.1162C15.2574 11.8564 14.8717 11.1191 14.2271 11.1191C13.5826 11.1191 13.2066 11.8516 13.2066 13.1162Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
